var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayeredStepsHaikei1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 430L113 430L113 417L225 417L225 430L338 430L338 471L450 471L450 457L563 457L563 469L675 469L675 460L788 460L788 472L900 472L900 455L900 601L900 601L788 601L788 601L675 601L675 601L563 601L563 601L450 601L450 601L338 601L338 601L225 601L225 601L113 601L113 601L0 601Z",
    fill: "#470077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 482L113 482L113 507L225 507L225 522L338 522L338 454L450 454L450 492L563 492L563 508L675 508L675 494L788 494L788 482L900 482L900 510L900 601L900 601L788 601L788 601L675 601L675 601L563 601L563 601L450 601L450 601L338 601L338 601L225 601L225 601L113 601L113 601L0 601Z",
    fill: "#3e59cf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 553L113 553L113 543L225 543L225 534L338 534L338 535L450 535L450 523L563 523L563 564L675 564L675 534L788 534L788 532L900 532L900 512L900 601L900 601L788 601L788 601L675 601L675 601L563 601L563 601L450 601L450 601L338 601L338 601L225 601L225 601L113 601L113 601L0 601Z",
    fill: "#0096ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredStepsHaikei1);
export default __webpack_public_path__ + "static/media/layered-steps-haikei (1).64bb95d56fe0b911a4577fc403e34308.svg";
export { ForwardRef as ReactComponent };